import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import api from '../services/api';
import { getMediaUrl } from '../services/api';

const DepartmentDetail = () => {
  const { slug } = useParams();
  const [department, setDepartment] = useState(null);
  const [officers, setOfficers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDepartment();
    loadOfficers();
  }, [slug]);

  const loadDepartment = async () => {
    try {
      const response = await api.get(`/departments/${slug}/`);
      setDepartment(response.data);
    } catch (error) {
      console.error('Error loading department:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadOfficers = async () => {
    try {
      const response = await api.get(`/officers/`, { params: { department: slug } });
      setOfficers(response.data);
    } catch (error) {
      console.error('Error loading officers:', error);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  if (!department) {
    return (
      <Container className="py-5">
        <h1>Department Not Found</h1>
        <Link to="/departments" className="btn btn-primary">Back to Departments</Link>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row>
        <Col lg={8}>
          <h1 className="page-title">{department.name}</h1>
          {department.image && (
            <img 
              src={getMediaUrl(department.image)} 
              alt={department.name}
              className="img-fluid mb-4 rounded"
            />
          )}
          <div dangerouslySetInnerHTML={{ __html: department.description }} />
        </Col>
        <Col lg={4}>
          <Card className="mb-4">
            <Card.Header className="bg-primary text-white">
              <h5 className="mb-0">Contact Information</h5>
            </Card.Header>
            <Card.Body>
              {department.head_officer && (
                <p><strong>Head:</strong> {department.head_officer}</p>
              )}
              {department.contact_email && (
                <p><FaEnvelope className="me-2" />{department.contact_email}</p>
              )}
              {department.contact_phone && (
                <p><FaPhone className="me-2" />{department.contact_phone}</p>
              )}
              {department.office_address && (
                <p><FaMapMarkerAlt className="me-2" />{department.office_address}</p>
              )}
            </Card.Body>
          </Card>

          {officers.length > 0 && (
            <Card>
              <Card.Header className="bg-primary text-white">
                <h5 className="mb-0">Officers</h5>
              </Card.Header>
              <ListGroup variant="flush">
                {officers.map(officer => (
                  <ListGroup.Item key={officer.id}>
                    <h6>{officer.name}</h6>
                    <p className="mb-0 small text-muted">{officer.designation}</p>
                    {officer.email && (
                      <p className="mb-0 small">{officer.email}</p>
                    )}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Card>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default DepartmentDetail;
